import PropTypes from 'prop-types';
import React from 'react';

function getArc(progress) {
  const arcStart = [11, 0.5];
  if (
    typeof progress !== 'number'
    || Number.isNaN(progress)
    || progress === 1
    || progress === 0
  ) {
    return arcStart;
  }
  const angleRadians = progress * 2 * Math.PI;
  const hypotenuse = 10.5;
  const center = [11, 11];
  const arcEndX = center[0] + Math.sin(angleRadians) * hypotenuse;
  const arcEndY = center[1] - Math.cos(angleRadians) * hypotenuse;

  if (progress >= 0.5) {
    // use large-arc flag in arc
    return `A 10.5 10.5 0 1 1 ${arcEndX} ${arcEndY}`;
  }
  return `A 10.5 10.5 0 0 1 ${arcEndX} ${arcEndY}`;
}

export default function ProgressCircle({ passed, goal }) {
  const progress = passed / goal;
  const arc = getArc(progress);
  return (
    <svg
      className={`progressCircle ${passed >= goal ? 'completed' : 'inProgress'}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 22 22"
    >
      {progress >= 1
        ? (
          <>
            <circle className="background" cx="11" cy="11" r="11" />
            <polyline className="checkMark" points="7.15 11.48 9.86 14.89 15.19 6.68" />
          </>
        ) : (
          <>
            <circle className="outline" cx="11" cy="11" r="10.5" />
            <path className="fill" d={`M11 11 v -10.5 ${arc}`} />
          </>
        )}
    </svg>
  );
}

ProgressCircle.propTypes = {
  passed: PropTypes.number.isRequired,
  goal: PropTypes.number.isRequired,
};
